/* Behaviors for the /artists directory page ("The Index").
   Filters, sort, search, card/list views, A-Z jump, reveal-on-scroll, and URL
   state, all over the build-rendered card grid. No-ops on other pages. */
(function () {
	"use strict";
	var root = document.querySelector(".directory");
	if (!root) return;

	var grid = document.getElementById("directoryGrid");
	var cards = Array.prototype.slice.call(grid.querySelectorAll(".directory-card"));
	var searchInput = document.getElementById("directorySearch");
	var resultEl = document.getElementById("directoryResult");
	var clearBtn = document.getElementById("directoryClear");
	var emptyEl = document.getElementById("directoryEmpty");
	var sortSel = document.getElementById("directorySort");
	var viewCards = document.getElementById("directoryViewCards");
	var viewList = document.getElementById("directoryViewList");
	var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	var state = { genre: "all", tier: "all", era: "all", q: "", terms: [], sort: "newest", view: "cards" };
	var total = cards.length;

	/* ── Reveal on scroll: cards rise + fade in as they enter, bands fade in, and each
	   card's sparkline draws when the card itself becomes visible.

	   The reveal is an enhancement laid over a page that is already readable. Cards and
	   bands are visible in plain CSS; the hidden start state (.is-reveal-pending) is put on
	   here and ONLY on elements that sit entirely below the fold, so nothing in the first
	   screenful blinks out and a directory whose script never runs still shows its cards.
	   It used to be the other way round: every card shipped at opacity 0 and waited for
	   this observer, so the grid was a blank rectangle until the script had parsed, walked
	   ~550 cards and finished its whole boot pass.

	   Every rect is read in one pass and every class written in a second, so the fold test
	   costs one layout rather than one per card. startReveal() runs last in the boot
	   sequence, once sorting and filtering have settled the layout it measures against. ── */
	/* What is on screen decides everything here, not a card count. The stylesheet's
	   entrance runs on a generous span of cards because CSS cannot ask whether an element
	   is in view and the animation has to start at first paint, well before this script
	   gets a turn. This pass reads the real fold and hides whatever is under it, including
	   cards the entrance already played to, which is why that animation fills backwards:
	   once it is over it holds no value, so .is-reveal-pending is free to take the card
	   back out and hand it to the observer. The span above the fold is therefore whatever
	   the window actually shows, on a laptop or on a 4K panel, and the number in the
	   stylesheet only has to be larger than a screenful rather than equal to one. */
	var revealEls = Array.prototype.slice.call(root.querySelectorAll("[data-reveal], .directory-card"));
	var startReveal = function () {
		if (!("IntersectionObserver" in window) || reducedMotion) return;
		var fold = window.innerHeight || document.documentElement.clientHeight;
		var below = [];
		for (var i = 0; i < revealEls.length; i++) {
			/* A card filtered out by a deep link measures all zeros, so it reads as "not
			   below the fold" and is left visible, which is what it needs to be the moment
			   the filter clears. */
			if (revealEls[i].getBoundingClientRect().top >= fold) below.push(revealEls[i]);
		}
		if (!below.length) return;
		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				entry.target.classList.remove("is-reveal-pending");
				io.unobserve(entry.target);
			});
		}, { threshold: 0.05, rootMargin: "0px 0px -40px 0px" });
		for (var j = 0; j < below.length; j++) {
			below[j].classList.add("is-reveal-pending");
			io.observe(below[j]);
		}
	};

	/* ── Filtering ── */
	var matchesGenre = function (card) {
		if (state.genre === "all") return true;
		var genres = card.dataset.genres || "";
		return state.genre.split("|").some(function (kw) { return genres.indexOf(kw) !== -1; });
	};
	var matchesTier = function (card) {
		return state.tier === "all" || card.dataset.tier === state.tier;
	};
	var matchesEra = function (card) {
		return state.era === "all" || card.dataset.era === state.era;
	};
	/* The hero on the home page cycles suggestions like "Who wrote Thriller?" and
	   "Does Taylor Swift write her own songs?", and its form submits straight here. Both
	   used to return nothing, because this matched the raw string against the artist's
	   name only. A suggestion the search cannot answer is worse than no suggestion.

	   So the query is reduced to the words that identify something: the question
	   scaffolding is dropped, and what is left has to appear in the artist's name or in
	   one of their album titles. "Who wrote Thriller?" becomes ["thriller"] and finds
	   Michael Jackson; "Does Taylor Swift write her own songs?" becomes
	   ["taylor","swift"]. A query that is nothing BUT scaffolding, like "Who actually
	   wrote this album?", reduces to nothing and shows everything, which is the honest
	   answer to a question with no subject in it. */
	var FILLER = ("who whom whose what which when where why how does do did is are was were "
		+ "the a an of on in for to by with and or "
		+ "wrote write writes writing written actually really ever never any anything anyone "
		+ "own his her their its my your our them they he she it this that these those "
		+ "song songs track tracks album albums record records lyric lyrics music "
		+ "artist artists band bands word words credit credits").split(" ");
	var STOP = Object.create(null);
	FILLER.forEach(function (w) { STOP[w] = true; });

	/* A band spelled out in words is searched for in digits and the other way round:
	   "30" has to reach Thirty Seconds to Mars, and "blink 182" has to reach Blink-182.
	   Each term expands into the alternatives, and a card matches if ANY of them is
	   present, so the digits and the words are interchangeable in a query. */
	var NUMBER_WORDS = [
		['one', '1'], ['two', '2'], ['three', '3'], ['four', '4'], ['five', '5'],
		['six', '6'], ['seven', '7'], ['eight', '8'], ['nine', '9'], ['ten', '10'],
		['eleven', '11'], ['twelve', '12'], ['twenty', '20'], ['thirty', '30'],
		['forty', '40'], ['fifty', '50'], ['sixty', '60'], ['hundred', '100']
	];
	var alternatives = function (word) {
		var out = [word];
		for (var i = 0; i < NUMBER_WORDS.length; i++) {
			if (NUMBER_WORDS[i][0] === word) out.push(NUMBER_WORDS[i][1]);
			else if (NUMBER_WORDS[i][1] === word) out.push(NUMBER_WORDS[i][0]);
		}
		return out;
	};

	var terms = function (q) {
		var raw = q.toLowerCase().replace(/[^a-z0-9\s'&-]+/g, " ").split(/\s+/);
		var kept = [];
		for (var i = 0; i < raw.length; i++) {
			var w = raw[i].replace(/^[-']+|[-']+$/g, "");
			if (w && !STOP[w]) kept.push(w);
		}
		// Everything was filler. Fall back to the raw words so a search for a real
		// artist called "The Band" still has something to match on.
		if (!kept.length && raw.join("").length && !q.trim().slice(-1).match(/\?/)) {
			for (var j = 0; j < raw.length; j++) if (raw[j]) kept.push(raw[j]);
		}
		return kept;
	};

	var matchesSearch = function (card) {
		if (!state.terms.length) return true;
		var hay = (card.dataset.name || "") + " | " + (card.dataset.titles || "");
		for (var i = 0; i < state.terms.length; i++) {
			var forms = alternatives(state.terms[i]);
			var hit = false;
			for (var j = 0; j < forms.length; j++) {
				if (hay.indexOf(forms[j]) !== -1) { hit = true; break; }
			}
			if (!hit) return false;
		}
		return true;
	};

	var apply = function () {
		var shown = 0;
		cards.forEach(function (card) {
			var visible = matchesGenre(card) && matchesTier(card) && matchesEra(card) && matchesSearch(card);
			/* Write only on a real change. The boot call otherwise touches the inline style
			   of every card in the directory to set it to what it already was, which is
			   pure style-recalc work sitting between the page and its first paint. */
			var display = visible ? "" : "none";
			if (card.style.display !== display) card.style.display = display;
			if (visible) shown++;
		});
		/* Same guard, and it keeps the boot call from announcing an unfiltered count into
		   the live region that the template already rendered. */
		var count = "Showing <strong>" + shown + "</strong> of " + total + " artists";
		if (resultEl.innerHTML !== count) resultEl.innerHTML = count;
		var filtered = state.genre !== "all" || state.tier !== "all" || state.era !== "all" || state.q;
		clearBtn.classList.toggle("is-visible", !!filtered);
		emptyEl.classList.toggle("is-visible", shown === 0);
		syncUrl();
	};

	/* ── Sorting: reorder card elements in place ── */
	var comparators = {
		newest: function (a, b) { return (b.dataset.added || "").localeCompare(a.dataset.added || ""); },
		"score-desc": function (a, b) { return (+b.dataset.score || 0) - (+a.dataset.score || 0); },
		"score-asc": function (a, b) { return (+a.dataset.score || 0) - (+b.dataset.score || 0); },
		name: function (a, b) { return (a.dataset.name || "").localeCompare(b.dataset.name || ""); },
		albums: function (a, b) { return (+b.dataset.albums || 0) - (+a.dataset.albums || 0); }
	};
	var applySort = function () {
		var cmp = comparators[state.sort] || comparators.newest;
		var was = cards.slice();
		cards.sort(cmp);
		var moved = false;
		for (var i = 0; i < cards.length; i++) {
			if (cards[i] !== was[i]) { moved = true; break; }
		}
		/* The template renders newest-first already, so the default boot sort agrees with
		   the DOM and there is nothing to move. Skipping it takes a full re-append of every
		   card, and the grid relayout it drags along, out of the load path; when the order
		   really does change, one fragment insert replaces the per-card appends. */
		if (!moved) return;
		var order = document.createDocumentFragment();
		cards.forEach(function (card) { order.appendChild(card); });
		grid.appendChild(order);
	};

	/* ── URL state (deep links from the home-page rails) ── */
	var syncUrl = function () {
		var params = new URLSearchParams();
		if (state.genre !== "all") params.set("genre", state.genre);
		if (state.tier !== "all") params.set("tier", state.tier);
		if (state.era !== "all") params.set("era", state.era);
		if (state.q) params.set("q", state.q);
		if (state.sort !== "newest") params.set("sort", state.sort);
		if (state.view !== "cards") params.set("view", state.view);
		var qs = params.toString();
		history.replaceState(null, "", qs ? "?" + qs : location.pathname);
	};
	var readUrl = function () {
		var params = new URLSearchParams(location.search);
		if (params.get("genre")) state.genre = params.get("genre");
		if (params.get("tier")) state.tier = params.get("tier");
		if (params.get("era")) state.era = params.get("era");
		if (params.get("q")) { state.q = params.get("q").toLowerCase(); state.terms = terms(state.q); searchInput.value = params.get("q"); }
		if (params.get("sort") && comparators[params.get("sort")]) { state.sort = params.get("sort"); sortSel.value = state.sort; }
		if (params.get("view") === "list") state.view = "list";
	};

	/* ── Chip rows ── */
	var wireRow = function (rowId, dataKey) {
		var row = document.getElementById(rowId);
		row.addEventListener("click", function (e) {
			var btn = e.target.closest("button[data-" + dataKey + "]");
			if (!btn) return;
			state[dataKey] = btn.dataset[dataKey];
			row.querySelectorAll("button").forEach(function (b) {
				var on = b === btn;
				b.classList.toggle("is-on", on);
				b.setAttribute("aria-pressed", on ? "true" : "false");
			});
			apply();
		});
	};
	wireRow("directoryGenreRow", "genre");
	wireRow("directoryTierRow", "tier");
	wireRow("directoryEraRow", "era");

	var syncChips = function () {
		[["directoryGenreRow", "genre"], ["directoryTierRow", "tier"], ["directoryEraRow", "era"]].forEach(function (pair) {
			var row = document.getElementById(pair[0]);
			row.querySelectorAll("button").forEach(function (b) {
				var on = b.dataset[pair[1]] === state[pair[1]];
				b.classList.toggle("is-on", on);
				b.setAttribute("aria-pressed", on ? "true" : "false");
			});
		});
	};

	/* Chip counts + disabled states (genre/tier/era) and the A-Z availability are
	   rendered at build time in the template, so nothing is computed here. */

	/* ── Search ── */
	/* What people look for here, and whether they found it. Reported once the typing
	   stops, not per keystroke: someone entering "chappell roan" letter by letter is
	   one search, and logging thirteen would drown the real queries in prefixes of
	   themselves. Each distinct query is sent once per page view for the same reason,
	   since backspacing one character and retyping it is not a second search.
	   analytics.js is production-only, so gtag is absent on a dev build. */
	var SEARCH_SETTLE_MS = 700;
	var searchTimer = null;
	var searchSeen = {};
	var trackSearch = function () {
		var q = state.q;
		// Under three characters is a prefix, not a question.
		if (q.length < 3 || searchSeen[q]) return;
		searchSeen[q] = true;
		if (typeof window.gtag !== "function") return;
		var shown = 0;
		cards.forEach(function (card) { if (card.style.display !== "none") shown++; });
		window.gtag("event", "directory_search", {
			search_term: q,
			result_count: shown,
			// A dedicated flag because "which searches found nothing" is the question
			// worth asking of this data, and it feeds the artist queue in TODO.md.
			found_nothing: shown === 0,
		});
	};

	var readSearch = function () {
		state.q = searchInput.value.trim().toLowerCase();
		state.terms = terms(state.q);
		apply();
		if (searchTimer) clearTimeout(searchTimer);
		searchTimer = setTimeout(trackSearch, SEARCH_SETTLE_MS);
	};
	searchInput.addEventListener("input", readSearch);
	/* The field is type="search", so the browser draws its own clear button inside it (the
	   X styled in artists.css). Pressing it, or Escape, empties the value and fires
	   "search"; Chromium also fires "input" but Safari does not, so both routes are wired
	   to the same read. Without this the X would blank the box and leave the grid filtered. */
	searchInput.addEventListener("search", readSearch);
	document.addEventListener("keydown", function (e) {
		if (e.key !== "/" || e.target.closest("input, textarea, select")) return;
		e.preventDefault();
		searchInput.focus();
	});

	/* ── Clear ── (top "Clear filters" link + the empty-state button share this) ── */
	var clearAll = function () {
		/* state.terms is what matchesSearch() actually reads; state.q only feeds the URL and
		   the "is anything filtered" test. Clearing one and not the other left the grid
		   filtered by a query that no longer existed anywhere on screen: the box was empty,
		   the Clear link had hidden itself, and a search that matched nothing held the empty
		   state up with no control left to escape it. */
		state.genre = "all"; state.tier = "all"; state.era = "all"; state.q = ""; state.terms = [];
		searchInput.value = "";
		syncChips();
		apply();
	};
	clearBtn.addEventListener("click", clearAll);
	var emptyClearBtn = document.getElementById("directoryEmptyClear");
	if (emptyClearBtn) emptyClearBtn.addEventListener("click", clearAll);

	/* ── Sort ── */
	sortSel.addEventListener("change", function () {
		state.sort = sortSel.value;
		applySort();
		syncUrl();
	});

	/* ── View toggle ── */
	var setView = function (view) {
		state.view = view;
		grid.classList.toggle("is-list", view === "list");
		viewCards.classList.toggle("is-on", view === "cards");
		viewList.classList.toggle("is-on", view === "list");
		viewCards.setAttribute("aria-pressed", view === "cards" ? "true" : "false");
		viewList.setAttribute("aria-pressed", view === "list" ? "true" : "false");
		syncUrl();
	};
	viewCards.addEventListener("click", function () { setView("cards"); });
	viewList.addEventListener("click", function () { setView("list"); });

	/* ── A-Z jump: switches to name sort, scrolls to the first match.
	   (Disabled letters are marked at build time.) ── */
	var alpha = document.getElementById("directoryAlpha");
	alpha.addEventListener("click", function (e) {
		var btn = e.target.closest("button[data-letter]");
		if (!btn || btn.disabled) return;
		if (state.sort !== "name") {
			sortSel.value = "name";
			/* Through a real change event rather than by hand. The listener above does
			   the state write, the re-sort and the URL sync, and the sort menu repaints
			   its button off the same event. Writing .value on its own re-ordered the
			   grid A to Z while leaving the control still reading "Newest first". */
			sortSel.dispatchEvent(new Event("change", { bubbles: true }));
		}
		var target = cards.slice().sort(comparators.name).filter(function (c) {
			return c.style.display !== "none" && (c.dataset.name || "").charAt(0) === btn.dataset.letter;
		})[0];
		if (target) target.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "center" });
		syncUrl();
	});

	/* ── Boot ── (masthead counts are comma-formatted at build time) */
	/* Sort menu, drawn to match the artist picker on /compare/ rather than leaving the
	   browser's own dropdown, which paints in the OS palette and ignores the page.

	   The markup is rendered by src/artists/index.njk. This used to build it: it wrapped the
	   native <select>, hid it, and put a button in its place, all after first paint. A
	   <select> is as wide as its longest option and the button is as wide as the current
	   label, so the control shrank by the difference the moment the script landed; the meta
	   row is a space-between flex row whose A-Z rail absorbs the slack and centres inside
	   it, so all 26 letters slid sideways with it. Rendered in its final shape, there is
	   nothing left to swap and nothing left to move.

	   The native <select> stays the source of truth: every existing read of
	   sortSel.value still works, readUrl() can still set it, and the clear-filters path
	   can still write "name" into it. This only wires the panel over the top and writes
	   back through .value plus a change event, so nothing below had to be rewritten.

	   Declared here, called from the boot sequence AFTER readUrl(), so a ?sort= deep
	   link has already written the select by the time the button paints off it. Called
	   before readUrl(), the button kept the label the template rendered and the page
	   arrived reading "Newest first" over a grid sorted by something else. */
	function sortMenu() {
		var wrap = root.querySelector('.directory-menu');
		var btn = wrap && wrap.querySelector('.directory-menu__btn');
		var list = wrap && wrap.querySelector('.directory-menu__list');
		if (!sortSel || !sortSel.options.length || !btn || !list) return;
		var opts = [].slice.call(sortSel.options);
		var items = [].slice.call(list.querySelectorAll('.directory-menu__opt'));
		// The two lists are rendered from one source in the template; if they ever drift,
		// leave the control alone rather than wire a menu that maps to the wrong option.
		if (items.length !== opts.length) return;

		var active = 0;
		function paint() {
			var pick = Math.max(0, opts.map(function (o) { return o.value; }).indexOf(sortSel.value));
			// Guarded: the boot call must not replace the server-rendered label with an
			// identical one, since even a same-width text swap is work in the load path.
			if (btn.textContent !== opts[pick].textContent) btn.textContent = opts[pick].textContent;
			items.forEach(function (li, i) { li.setAttribute('aria-selected', i === pick ? 'true' : 'false'); });
			return pick;
		}
		function highlight(i) {
			active = (i + items.length) % items.length;
			items.forEach(function (li, n) { li.classList.toggle('is-active', n === active); });
			list.setAttribute('aria-activedescendant', items[active].id);
			items[active].scrollIntoView({ block: 'nearest' });
		}
		function open() {
			list.hidden = false;
			btn.setAttribute('aria-expanded', 'true');
			highlight(paint());
		}
		function close(focus) {
			list.hidden = true;
			btn.setAttribute('aria-expanded', 'false');
			list.removeAttribute('aria-activedescendant');
			if (focus) btn.focus();
		}
		function choose(i) {
			sortSel.value = opts[i].value;
			// The listener further down does the actual re-sort; going through a real
			// change event keeps one code path for script and for the native control.
			sortSel.dispatchEvent(new Event('change', { bubbles: true }));
			paint();
			close(true);
		}
		
		btn.addEventListener('click', function () { list.hidden ? open() : close(false); });
		list.addEventListener('click', function (e) {
			var li = e.target.closest && e.target.closest('.directory-menu__opt');
			if (li) choose(items.indexOf(li));
		});
		list.addEventListener('mousemove', function (e) {
			var li = e.target.closest && e.target.closest('.directory-menu__opt');
			if (li) highlight(items.indexOf(li));
		});
		wrap.addEventListener('keydown', function (e) {
			var k = e.key;
			if (list.hidden) {
				if (k === 'ArrowDown' || k === 'Enter' || k === ' ') { e.preventDefault(); open(); }
				return;
			}
			if (k === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
			else if (k === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
			else if (k === 'Home') { e.preventDefault(); highlight(0); }
			else if (k === 'End') { e.preventDefault(); highlight(items.length - 1); }
			else if (k === 'Enter' || k === ' ') { e.preventDefault(); choose(active); }
			else if (k === 'Escape') { e.preventDefault(); close(true); }
			else if (k === 'Tab') { close(false); }
		});
		document.addEventListener('click', function (e) {
			if (!list.hidden && !wrap.contains(e.target)) close(false);
		});
		// readUrl() and the clear-filters path both write straight to the select, so the
		// button has to repaint from it rather than from its own memory.
		sortSel.addEventListener('change', paint);
		paint();
	}

	readUrl();
	sortMenu();
	syncChips();
	if (state.view === "list") setView("list");
	applySort();
	apply();
	/* Last, so the fold test measures the layout the reader is actually looking at. */
	startReveal();
	/* Retire the CSS entrance once it has played. While those rules match they outrank the
	   card's own hover rule, and leaving them in place would also replay the fade every time
	   the pointer left one of the top cards. With .is-entered on the grid they stop matching
	   and every card hovers the same way.

	   A timer rather than the last card's animationend: which card is last depends on how
	   many the stylesheet reaches, and tying this to that figure is the coupling that made
	   the entrance a screen-size question in the first place. The cascade's own arithmetic
	   bounds it instead, 0.36s of stagger and a 0.32s fade, so 1.2s clears it with room and
	   holds for a card whose animation never fires at all, such as one a deep-link filter
	   had already hidden. */
	var entranceOver = function () { grid.classList.add("is-entered"); };
	setTimeout(entranceOver, 1200);
})();
